import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ToastFacade } from './+state';
import { ToastStateModule } from './+state/toast.state.module';

@NgModule({
  imports: [CommonModule, ToastStateModule],
})
export class DomainToastModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainToastModule,
      providers: [ToastFacade],
    };
  }
}
